import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { mockMembershipTiers, mockFormSubmit } from '../mock';
import { toast } from 'sonner';

export const MembershipSection = () => {
  const [selectedTier, setSelectedTier] = useState(null);

  const benefits = [
    'Monthly live workshops + recorded library (Success Path curriculum)',
    'Business incubator with micro-grants and mentorship',
    'Annual pitch event — connect with angel investors and sponsors',
    'Global networking and accountability matching',
    'Monthly goal-setting and 911 Business Emergency calls',
    'Access to Closing the Gap humanitarian campaigns',
    'Members-only referral network',
    'Professional development tools and resources'
  ];

  const handleJoin = async (tier) => {
    window.open(tier.link, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="membership" className="py-20" style={{ backgroundColor: 'var(--white-soft)' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="lhsc-heading text-3xl md:text-5xl mb-6">
            JOIN THE MOVEMENT. CHOOSE YOUR LEVEL.
          </h2>
          <p className="lhsc-subheading text-base" style={{ color: 'var(--slate-grey)' }}>
            All tiers include full access to education, community, and impact opportunities.
          </p>
        </div>

        {/* Three Membership Tier Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {mockMembershipTiers.map((tier) => (
            <div
              key={tier.id}
              className="border border-[var(--pink-dusty)] bg-white overflow-hidden flex flex-col"
            >
              {/* Oval Decorative Accent */}
              <div 
                className="h-24 relative overflow-hidden"
                style={{ backgroundColor: 'var(--pink-blush)' }}
              >
                <div 
                  className="absolute -top-12 left-1/2 transform -translate-x-1/2 w-40 h-40 rounded-full border-2"
                  style={{ borderColor: 'var(--mauve-rose)' }}
                ></div>
              </div>

              <div className="p-8 flex-1 flex flex-col">
                <h3 className="lhsc-heading text-xl mb-4 text-center">{tier.name}</h3>
                
                <div className="text-center mb-4">
                  <div className="text-4xl lhsc-heading mb-2" style={{ color: 'var(--mauve-rose)' }}>
                    ${tier.price}
                  </div>
                  <p className="lhsc-subheading text-xs" style={{ color: 'var(--slate-grey)' }}>
                    CAD / month
                  </p>
                  <p className="lhsc-body text-sm mt-2" style={{ color: 'var(--slate-grey)' }}>
                    or ${tier.annualPrice} CAD / year
                  </p>
                </div>

                <div className="p-4 border border-[var(--pink-dusty)] mb-6 flex-1" style={{ backgroundColor: 'var(--pink-blush)' }}>
                  <p className="lhsc-body text-sm italic text-center">
                    "{tier.tagline}"
                  </p>
                </div>

                <button
                  onClick={() => handleJoin(tier)}
                  className="w-full py-3 rounded-md text-white font-semibold text-sm tracking-wider"
                  style={{ 
                    backgroundColor: 'var(--mauve-rose)',
                    fontFamily: 'Josefin Sans, sans-serif',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontWeight: 500
                  }}
                >
                  Join Now
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* All Tiers Include */}
        <div className="max-w-4xl mx-auto bg-white p-8 border border-[var(--pink-dusty)]">
          <h3 className="lhsc-heading text-2xl mb-6 text-center">All Tiers Include</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start">
                <Check size={20} className="mr-3 flex-shrink-0 mt-1" style={{ color: 'var(--mauve-rose)' }} />
                <span className="lhsc-body text-sm">{benefit}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};
